import React from "react"
import SweetAlert from "react-bootstrap-sweetalert"

const CustomSweetAlert = ({ message, ...props }) => (
  <SweetAlert {...props} style={{ fontFamily: "'Muli', sans-serif" }}>
    {message}
  </SweetAlert>
)

export default CustomSweetAlert



// WEBPACK FOOTER //
// ./src/components/custom-sweetalert/CustomSweetAlert.js